import { FormCheckProps } from "react-bootstrap/FormCheck";
import Form from "react-bootstrap/Form";

import classNames from "clsx";

import "./styles.scss";

export type Props = FormCheckProps & {
	value: string;
	label: string;
	id?: string;
	currentValue?: string | number | boolean | undefined;
	solid?: boolean;
	containerClassName?: string;
};

export function FormRadio({
	value,
	label,
	currentValue,
	id,
	solid = true,
	containerClassName,
	...rest
}: Props) {
	return (
		<div
			className={classNames(
				"form-check form-check-custom",
				solid && "form-check-solid",
				containerClassName
			)}
		>
			<Form.Check
				type="radio"
				id={id}
				value={value}
				// eslint-disable-next-line eqeqeq
				checked={value == currentValue}
				onChange={() => {}}
				{...rest}
			/>
			<label
				className={classNames("form-check-label", !rest.disabled && "text-gray-800")}
				htmlFor={id}
			>
				{label}
			</label>
		</div>
	);
}
